import ApplicationAdapter from 'eflex/adapters/application';

export default class TaskConfigAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
